import { ISelectOption } from "../../components/Forms/Select/Select.interface";
import { APP_CONFIGS } from "../constants";
import { IRequest, IRequestError } from "../interfaces/authentication.interface";
import { IContact, IContactFormResponse } from "../interfaces/contacts.interface";
import { request, strapiRequest } from "./requests.service";

export const getSubjects = async (locale: string): Promise<IRequest<ISelectOption[]>> => {
    try {
        const query = `
            query ContactForm($filters: ComponentItemTextFiltersInput, $locale: I18NLocaleCode) {
                contactForm(locale: $locale) {
                    subjects(filters: $filters) {
                        label
                        value
                    }
                }
            }`;

        const variables = {
            locale,
            filters: {
                platforms: {
                    key: {
                        eq: APP_CONFIGS.key
                    }
                }
            }
        };

        const response = await strapiRequest.post<IContactFormResponse>(`/graphql`, {
            operationName: "ContactForm",
            query,
            variables
        });

        return { success: true, data: response.data.data.contactForm?.subjects ?? [] };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};

export const sendContact = async (contact: IContact, locale: string): Promise<IRequest<any | IRequestError>> => {
    try {


        const response = await request.post<any>(`/email/contact-feedback?locale=${locale}`, { platform: APP_CONFIGS.key, ...contact });

        return { success: true, data: response };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
}